import { path } from "ramda";

const getFile = path([0, "file"]);
export const mountImagesForm = ({
  imagemFrente,
  imagemLateral,
  imagemCostas,
}) => {
  const frente = getFile(imagemFrente);
  const lateral = getFile(imagemLateral);
  const costas = getFile(imagemCostas);
  if (frente || lateral || costas) {
    const formData = new FormData();
    formData.append("imagemFrente", frente);
    formData.append("imagemLateral", lateral);
    formData.append("imagemCostas", costas);
    return formData;
  }
  return null;
};
